import browser from "webextension-polyfill";
import { detectionEventName, detectionMessage } from "../shared";
export function forwardDetectionEvent() {
    void browser.runtime.sendMessage({ type: detectionMessage });
}
export function start() {
    document.addEventListener(detectionEventName, forwardDetectionEvent);
}
start();
